import { render, staticRenderFns } from "./PostProgram.vue?vue&type=template&id=0071b7df&"
import script from "./PostProgram.vue?vue&type=script&lang=js&"
export * from "./PostProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports